import { render, staticRenderFns } from "./FormEquity.vue?vue&type=template&id=9221cb40&"
import script from "./FormEquity.vue?vue&type=script&lang=js&"
export * from "./FormEquity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports